import React from "react";
import Headline from "./Headline";
import LocationsApi from "../../api-services/locations-api.service";
import { Flex, notification } from "antd";
import HomeLink from "../../widgets/HomeLink";
import { useParams } from "react-router-dom";
import Postcards from "../../components/shared/Postcards";
import PaginationWidget from "../../widgets/PaginationWidget";

const LIMIT = 30;
const bannerPath = '/iceholidays-assets/images/gd_classic.png';

const series = {
  "gd-classics": "GD_SG_Standard",
  // "gd-indepth": "GD_In_Depth"
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()}/>;
}

class SeriesPage extends React.Component <{params}>  {
  locationsApi = new LocationsApi;

  state = {
    countries: [],
    header: "",
    description: "",
    breadcrumbs:[],
    type: this.props.params['type'],
    total: 0,
    currentPage: 1
  }

  componentDidMount() {
    this.getLocations(this.state.type);
  }

  componentDidUpdate(prevProps: Readonly<{ params: any; }>, prevState: Readonly<{}>, snapshot?: any): void {    
    const type = this.props.params['type'];
    if(prevProps.params.type != type){
      this.getLocations(type);
    }
  }

  getLocations(type, page=1){
    const seriesByType = series[type];
    this.locationsApi.getLocationGroup(seriesByType, {page, limit: LIMIT})
      .then(({group, total}) => {
        if(group){
          var header = group.name;
          var breadcrumbs = [
            { title: <HomeLink/>},
            { title: header},
          ];
          this.setState({countries: group.locations, breadcrumbs, header, description: group?.description, type, currentPage: page, total})
        }
      })
      .catch(error => {
        notification.error({ message: `An error occured while loading ${seriesByType}.`});
      });
  }

  handlePageChange = (page) => {
    this.getLocations(this.state.type, page);
  }


  render(){
    const {breadcrumbs, type, header, description, countries} = this.state;

    return (
      <div id="gd-classic" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={countries[0]?.cover || bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            <img src="/iceholidays-assets/images/gd-logo_round.png" alt="GD Logo" />
            {header}
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          <div className="introduction">
            <Flex vertical gap={8}>
              <div className="introduction_header"> <h1>Introduction</h1> </div>
              <div className="introduction_body">
                {description}
              </div>
            </Flex>
          </div>

          <Postcards items={this.state.countries} link={`series-tour/${type}/`}/>

          {this.state.total > 0 && <PaginationWidget totalItems={this.state.total} current={this.state.currentPage} maxItemsPerPage={LIMIT} pageChange={this.handlePageChange}/>}
        </div>

      </div>
    )
  }
}

export default withParams(SeriesPage);